export default __webpack_public_path__ + "static/media/atpar3.2e0cf8d9.png";